// src/utils/dashboardCache.js
const CACHE_KEYS = {
  STATS: 'orbit_dashboard_stats',
  TODAY_COMPLETED: 'orbit_dashboard_today_completed',
  OVERDUE_TASKS: 'orbit_dashboard_overdue_tasks',
  OVERDUE_STATS: 'orbit_dashboard_overdue_stats',
  MY_TASKS: 'orbit_dashboard_my_tasks',
  DEPARTMENT_TASKS: 'orbit_dashboard_department_tasks',
};

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

/**
 * Cache utility for dashboard data
 */
class DashboardCache {
  /**
   * Set data in cache with timestamp
   */
  static setCache(key, data) {
    try {
      const cacheItem = {
        data,
        timestamp: Date.now(),
      };
      localStorage.setItem(key, JSON.stringify(cacheItem));
    } catch (error) {
      console.warn('Failed to cache dashboard data:', error);
    }
  }

  /**
   * Get data from cache if not expired
   */
  static getCache(key, maxAge = CACHE_DURATION) {
    try {
      const cached = localStorage.getItem(key);
      if (!cached) return null;

      const cacheItem = JSON.parse(cached);
      const isExpired = Date.now() - cacheItem.timestamp > maxAge;

      if (isExpired) {
        localStorage.removeItem(key);
        return null;
      }

      return cacheItem.data;
    } catch (error) {
      console.warn('Failed to read cached dashboard data:', error);
      return null;
    }
  }

  /**
   * Clear specific cache entry
   */
  static clearCache(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn('Failed to clear cache:', error);
    }
  }

  /**
   * Clear all dashboard cache
   */
  static clearAllCache() {
    Object.values(CACHE_KEYS).forEach(key => {
      this.clearCache(key);
    });
  }

  /**
   * Check if cache exists and is valid
   */
  static isCacheValid(key, maxAge = CACHE_DURATION) {
    try {
      const cached = localStorage.getItem(key);
      if (!cached) return false;

      const cacheItem = JSON.parse(cached);
      return Date.now() - cacheItem.timestamp <= maxAge;
    } catch (error) {
      return false;
    }
  }
}

export { DashboardCache, CACHE_KEYS };